export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.1342b7d0.worker.js");
}
